import React from "react";
import ReactDOM from "react-dom";

export default class Portal extends React.Component {
  constructor(props) {
    super(props);
    this.el = document.createElement("div");
    this.portalRoot = document.getElementById("portal");
  }

  componentDidMount() {
    this.portalRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    this.portalRoot.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}
